'use client';

import { RootState } from '@/store/store';
import { createSlice } from '@reduxjs/toolkit';

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuthenticated: false,
    forceLogout: false,
  },
  reducers: {
    logIn: (state) => {
      state.isAuthenticated = true;
      state.forceLogout = false;
    },
    logOut: (state) => {
      state.isAuthenticated = false;
      state.forceLogout = true;
    },
  },
});

export const { logIn, logOut } = authSlice.actions;
export const selectAuth = (state: RootState) => state.auth;
export default authSlice.reducer;
